import React from 'react'

export default ({ className }) => (
    <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" className={className} xlink="http://www.w3.org/1999/xlink">
        <g id="7-9" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="RM---answer-autogen-question" transform="translate(-904.000000, -1081.000000)" stroke="#FFFFFF">
                <g id="textbox---empty" transform="translate(261.000000, 1028.000000)">
                    <g id="Group-6" transform="translate(0.000000, 44.000000)">
                        <g id="expand-icon" transform="translate(644.070073, 10.000000)">
                            <path d="M4.58540146,6.75 L0,11.25" id="Path"></path>
                            <polyline id="Path" points="11.4635036 3.375 11.4635036 0 8.02445255 0"></polyline>
                            <polyline id="Path" points="0 7.875 0 11.25 3.43905109 11.25"></polyline>
                            <path d="M11.4635036,0 L6.87810219,4.5" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
